import mvtFeed from '@/common/components/mvtfeed/mvt-feed.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageFeed',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtFeed,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        isNotification() {
            return this.glb.pageType == 'vfeed_notification';
        },
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
